/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("ExamGradesController", function ExamGradesController(
	$location,
	$scope,
	$rootScope,
	$routeParams,
	$http,
	$document,

	dxExamsNavigator,
	DX_EXAMS_STEPS,
	ExamRepository,
	group,
	dxSession,
	dxLocalize,
	faults,
	DX_URLS,
	validationService,
	DX_EXAM_PARTS,
	dxEvent,
	DX_SPELLCHECKSETTING,
	examStatus,
	dxApi,
	DX_QUESTION_TYPE,
	DX_GRADING_TYPES,
	DX_STUDENT_SORT_PREDICATE,
	NodeRepository,
	RoleTypeEnum,

	dxDialog,
	dxAngularConstantHelper
) {
	"use strict";

	var examId = parseInt($routeParams.id, 10);

	var examGroup = null;

	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;
	$scope.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;

	$scope.Urls = DX_URLS;

	function getId(item) {
		return item.id;
	}

	$scope.reqs = {
		exam: false,
		grades: false,
	};

	$scope.sharedToUser = [];
	$scope.nrOfSharedUsers = 0;

	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	function onNodeLoadSuccess(node) {
		$scope.node = node;
	}

	$scope.tempState = {
		subView: "default",
		shareGradingWork: {
			email: "",
			questions: [],
			students: [],
		},
		publish: {
			parts: DX_EXAM_PARTS.NONE,
		},
		notifications: false,
		syncToLMS: true,
	};

	$scope.indicateUnanswered = false;

	$scope.isSubView = function isSubView(viewName) {
		return viewName === $scope.tempState.subView;
	};

	$scope.openSubView = function openSubView(viewName) {
		if (viewName === "publish") {
			$scope.tempState.publish.parts = $scope.exam.publishedParts || $scope.tempState.publish.parts || DX_EXAM_PARTS.ALL_PARTS;
		}
		if (viewName === "shareGradingWork") {
			$scope.sharedTo();
		}
		$scope.tempState.subView = viewName;
	};

	function loadExam() {
		return ExamRepository.load(examId).then(function success(res) {
			$scope.reqs.exam = true;
			$scope.exam = res;

			$scope.exam.getGrades(true).then(function getGradesSuccess() {
				$scope.exam.students.forEach(function forEachStudent(student) {
					if (student.redactedPii) {
						student.firstName = dxLocalize.get("RedactedPii.StudentName");
						student.lastName = "";
						student.studentCode = "";
					}
				});

				$scope.studentsWritingDigitally = $scope.exam.students.filter(function writingDigitally(student) {
					return student.writingDigitally;
				});

				var sortPredicate;
				if ($scope.exam.anonymous) {
					sortPredicate = DX_STUDENT_SORT_PREDICATE.ANONYMOUS_ID;
				} else {
					sortPredicate = DX_STUDENT_SORT_PREDICATE.LAST_NAME;
				}

				$rootScope.studentSortOptions = {
					predicate: sortPredicate,
					reverse: false,
				};

				$scope.studentsNotWritingDigitally = $scope.exam.students.filter(function notWritingDigitally(student) {
					return !student.writingDigitally;
				});

				var allQuestionsIds = $scope.exam.questions.map(getId);
				var allStudentsWritingDigitallyIds = $scope.studentsWritingDigitally.map(getId);

				$scope.tempState.shareGradingWork.questions = allQuestionsIds.slice();
				$scope.tempState.shareGradingWork.students = allStudentsWritingDigitallyIds.slice();

				$scope.reqs.grades = true;

				if ($scope.userIsExamOwnerOrAdmin() && !$scope.exam.isGraded && isExamScoreBased($scope.exam)) {
					setTotalScores($scope.exam);
				}
			});

			if ($scope.exam.groupId && $scope.userIsExamOwnerOrAdmin()) {
				group.get($scope.exam.groupId).then(function groupGetSuccess(response) {
					examGroup = response;
				});
			}

			if ($scope.userIsExamOwnerOrAdmin()) {
				dxApi.v1.gradings.shares.get(examId).then(function onSuccess(response) {
					$scope.hasSharedGrading = response.data.users.length > 0;
				});
			}
		});
	}

	function setTotalScores(exam) {
		exam.students.forEach(function forEachFn(student) {
			if (!student.isFinalGradeSet() &&
				isAllAnswersGraded(student.answers) &&
				(student.finalGrade.finalGradeType === 1 || student.finalGrade.finalGradeType === 0)
			) {
				var totalScore = getTotalScore(student.answers);
				student.finalGrade.grade = totalScore.toString();
				dxApi.legacy.finalGrades.post(student.finalGrade);
			}
		});
	}

	function isAllAnswersGraded(answers) {
		for (var i = 0; i < answers.length; i++) {
			if (!answers[i].isGraded()) {
				return false;
			}
		}
		return true;
	}

	function getTotalScore(answers) {
		return answers.reduce(function reduceFn(sum, answer) {
			return sum + answer.grade.score;
		}, 0);
	}

	function isExamScoreBased(exam) {
		return exam.gradingType === DX_GRADING_TYPES.SCORE;
	}

	$scope.isValid = {
		shareGradingWork: {
			all: null,
			email: null,
			questions: null,
			students: null,
			server: null,
		},
		print: {
			all: null,
			questions: null,
			students: null,
		},
	};

	$scope.validate = {
		shareGradingWork: {
			all: function all() {
				var feature = $scope.isValid.shareGradingWork;
				feature.all = feature.email && feature.questions && feature.students;
				return feature.all;
			},
			email: function email() {
				var isValid = (validationService.isEmailValid($scope.tempState.shareGradingWork.email)) && !$scope.isUserEmail($scope.tempState.shareGradingWork.email);
				$scope.isValid.shareGradingWork.email = isValid;
				return $scope.validate.shareGradingWork.all();
			},
			questions: function questions() {
				var isValid = !!$scope.tempState.shareGradingWork.questions.length;
				$scope.isValid.shareGradingWork.questions = isValid;
				return $scope.validate.shareGradingWork.all();
			},
			students: function students() {
				var isValid = !!$scope.tempState.shareGradingWork.students.length;
				$scope.isValid.shareGradingWork.students = isValid;
				return $scope.validate.shareGradingWork.all();
			},
		},
	};

	$scope.$watch("tempState.shareGradingWork.email", $scope.validate.shareGradingWork.email);
	$scope.$watch("tempState.shareGradingWork.questions.length", $scope.validate.shareGradingWork.questions);
	$scope.$watch("tempState.shareGradingWork.students.length", $scope.validate.shareGradingWork.students);

	$scope.userIsExamOwnerOrAdmin = function userIsExamOwnerOrAdmin() {
		return dxSession.getUser().id === $scope.exam.userId || !$scope.exam.sharedBy || $scope.userIsRole("admin");
	};

	$scope.shareGradingWork = function shareGradingWork() {
		var data = $scope.tempState.shareGradingWork;
		return $scope.exam.gradingShareWith(data.email, data.questions, data.students).then(function success(response) {
			var serverValid = false;

			if (response.faults === null || typeof response.faults === "undefined") {
				serverValid = true;
				$scope.openSubView("default");
				$rootScope.$broadcast("notification:success", dxLocalize.get("YouSharedXWithY", $scope.exam.title, data.email));
			} else if (response.faults.indexOf(faults.USER_NOT_FOUND) >= 0) {
				data.serverError = dxLocalize.get("CouldNotShareExamNoEmailX", data.email);
			} else if (response.faults.indexOf(faults.FORBIDDEN) >= 0) {
				data.serverError = dxLocalize.get("CouldNotShareExamCantGrade", data.email);
			} else if (response.faults.indexOf(faults.UNSPECIFIED) >= 0) {
				data.serverError = dxLocalize.get("CouldNotShareGradingOwner", data.email);
			} else {
				data.serverError = dxLocalize.get("FailedToShareExam");
			}

			$scope.isValid.shareGradingWork.server = serverValid;
		});
	};

	$scope.removeAccess = function removeAccess(userId, index) {
		dxApi.v1.gradings.shares.delete($scope.exam.id, userId).then(function success() {
			$scope.sharedToUser.splice(index, 1);
		});
	};

	function removeYourShare() {
		dxApi.v1.gradings.shares.delete($scope.exam.id, dxSession.getUser().id).then(function success() {
			$location.path(DX_URLS.get("exams"));
		}).finally(function closeDialog() {
			dxDialog.closeMostRecent();
		});
	}

	$scope.openConfirmSelfRemoveShareDialog = function openConfirmSelfRemoveShareDialog() {
		dxDialog.confirm({
			title: dxLocalize.get("RemoveGradingShare"),
			body: dxLocalize.get("DoYouWantToRemoveGradingShareForExam", $scope.exam.title),
			acceptText: dxLocalize.get("YesRemoveShare"),
			rejectText: dxLocalize.get("Cancel"),
			acceptCallback: removeYourShare,
		});
	};

	$scope.publishResults = function publishResults() {
		$scope.exam.setPublished($scope.tempState.publish.parts, $scope.tempState.notifications).
		then(function success(response) {
			if (response) {
				if ($scope.isLMSConnected() && $scope.tempState.syncToLMS) {
					$scope.exam.syncToLMS().then(syncSuccess, syncFail);
				} else {
					$rootScope.$broadcast("notification:success", dxLocalize.get("PublishedTheResults"));
					$location.url(DX_URLS.get("exams") + dxExamsNavigator(DX_EXAMS_STEPS.published, examId));
				}
			} else {
				$rootScope.$broadcast("notification:error", dxLocalize.get("FailedToPublishResults"));
			}
		}, function failed() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("FailedToPublishResults"));
		});

		function syncSuccess(response) {
			if (response.length === 0) {
				$rootScope.$broadcast("notification:success", dxLocalize.get("PublishedTheResults"));
				$location.url(DX_URLS.get("exams") + dxExamsNavigator(DX_EXAMS_STEPS.published, examId));
				return;
			}

			var students = $scope.exam.students.filter(function filterStudents(student) {
				for (var i = 0; i < response.length; i++) {
					if (student.id === response[i].id) {
						return true;
					}
				}
				return false;
			});

			showFailedToSyncDialog(students);
		}

		function syncFail() {
			showFailedToSyncDialog($scope.exam.students);
		}

		function showFailedToSyncDialog(students) {
			var scope = $rootScope.$new();
			scope.students = students;
			scope.anonymous = $scope.exam.anonymous;
			scope.dxDialog = dxDialog;
			scope.$on("$destroy", function navigateToExams() {
				$rootScope.$broadcast("notification:success", dxLocalize.get("PublishedTheResults"));
				$location.url(DX_URLS.get("exams") + dxExamsNavigator(DX_EXAMS_STEPS.published, examId));
			});

			dxDialog.show({
				templateUrl: "partials/popups/students-list.html",
				$scope: scope,
			});
		}
	};

	$scope.unpublishResults = function unpublishResults() {
		return $scope.exam.setPublished(0, false).then(function success(response) {
			if (response) {
				$rootScope.$broadcast("notification:success", dxLocalize.get("UnpublishedTheResults"));

				var examsStep = $scope.exam.examStatus === examStatus.GRADED ? DX_EXAMS_STEPS.graded : DX_EXAMS_STEPS.ungraded;
				$location.url(DX_URLS.get("exams") + dxExamsNavigator(examsStep, examId));
			} else {
				$rootScope.$broadcast("notification:error", dxLocalize.get("FailedToUnpublishResults"));
			}
		}, function failed() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("FailedToUnpublishResults"));
		});
	};

	$scope.confirmToggleAnonymous = function confirmToggleAnonymous() {
		var anonymous = $scope.exam.anonymous;

		dxDialog.confirm({
			title: dxLocalize.get(anonymous ? "DeAnonymize" : "AnonymizeExam"),
			body: dxLocalize.get(anonymous ? "DeAnonymizeExplanation" : "AnonymizeExplanation"),
			acceptText: dxLocalize.get(anonymous ? "DeAnonymize" : "AnonymizeExam"),
			acceptCallback: $scope.toggleAnonymous,
			rejectText: dxLocalize.get("Cancel"),
		});
	};

	$scope.canChangeAnonymization = function canChangeAnonymization() {
		var examIsGraded = $scope.exam.examStatus === examStatus.GRADED && $scope.exam.userId === dxSession.getUser().id;
		var adminOnExamOrganization = dxSession.getRole().organizationId === $scope.exam.organizationId && dxSession.getRole().roleType === RoleTypeEnum.ADMIN;

		return examIsGraded || adminOnExamOrganization;
	};

	$scope.toggleAnonymous = function toggleAnonymous() {
		var data = {
			examId: $scope.exam.id,
			anonymous: !$scope.exam.anonymous,
		};

		$scope.exam.anonymous = data.anonymous;

		$http.post(DX_URLS.get("examSetAnonymous"), data).then(function success(response) {
			if (response.status !== 200) {
				$scope.exam.anonymous = !data.anonymous;
				return $scope.exam.anonymous;
			}

			return loadExam();
		});

		dxDialog.closeMostRecent();
	};

	$scope.uploadOfflinefile = function uploadOfflinefile(offlineFileExamId) {
		var scope = $rootScope.$new();
		scope.examId = offlineFileExamId;
		scope.node = $scope.node;
		scope.onCompleteAll = function onCompleteAll() {
			return loadExam();
		};
		dxDialog.show({
			templateUrl: "partials/popups/upload-offline-answer-file.html",
			$scope: scope,
		});
	};

	$scope.isExamEnded = function isExamEnded() {
		return $scope.exam.examStatus > examStatus.ACTIVE;
	};

	$scope.isPublished = function isPublished() {
		return $scope.exam.examStatus === examStatus.PUBLISHED;
	};

	$scope.isUserEmail = function isUserEmail(sharingEmail) {
		for (var i = 0; i < dxSession.getUser().email.length; i++) {
			var email = dxSession.getUser().email[i];
			if (email === sharingEmail) {
				return true;
			}
		}

		return false;
	};

	$scope.isLMSConnected = function isLMSConnected() {
		if (examGroup) {
			return examGroup.externallyManaged;
		}

		return false;
	};

	$scope.sharedTo = function sharedTo() {
		dxApi.v1.gradings.shares.get(examId).then(function onSuccess(response) {
			$scope.sharedToUser = response.data.users || [];
			$scope.ownerName = response.data.ownerName;
		});
	};

	$scope.getOwner = function getOwner() {
		if (!$scope.ownerName) {
			return dxLocalize.get("ThisUserIsDeleted");
		}

		return $scope.ownerName;
	};

	$scope.isOwner = function isOwner() {
		return $scope.exam.userId === dxSession.getUser().id;
	};

	$scope.isShared = function isShared() {
		return $scope.sharedToUser.length > 0;
	};

	$scope.getDisplayName = function setDisplayName() {
		return $scope.exam.title;
	};

	$scope.getSpreadsheetUrl = function getSpreadsheetUrl(indicateUnanswered) {
		return dxApi.v1.gradesSpreadsheet.url($scope.exam.id, indicateUnanswered, $rootScope.studentSortOptions);
	};

	$scope.toggleDropdown = function toggleDropdown(event) {
		event.stopPropagation();
		$document.find(".dropdown_menu").dropdown("toggle");
	};

	$scope.toggleIndicateUnanswered = function toggleIndicateUnanswered(event) {
		event.stopPropagation();
		$scope.indicateUnanswered = !$scope.indicateUnanswered;
	};

	function wordGapEvent() {
		for (var i = 0; i < $scope.exam.questions.length; i++) {
			if ($scope.exam.questions[i].type === DX_QUESTION_TYPE.WORD_GAP) {
				dxEvent.create(DX_EVENT_NAME.EventWordGapGradingAccessed);
				return;
			}
		}
	}

	function usbAudioEvent() {
		for (var i = 0; i < $scope.exam.students.length; i++) {
			if ($scope.exam.students[i].accessibilitySettings.audioFile === true) {
				dxEvent.create(DX_EVENT_NAME.EventUsbAudioGradingAccessed);
				return;
			}
		}
	}

	function immersiveReaderEvent() {
		for (var i = 0; i < $scope.exam.students.length; i++) {
			if ($scope.exam.students[i].accessibilitySettings.immersiveReader === true) {
				dxEvent.create(DX_EVENT_NAME.EventImmersiveReaderExamGradingAccessed);
				return;
			}
		}
	}

	function lockedQuestionSequenceExamEvent() {
		if ($scope.exam.lockedQuestionSequence) {
			dxEvent.create(DX_EVENT_NAME.EventLockedQuestionSequenceGradingAccessed);
		}
	}

	// Initialize
	loadExam().then(function checkForEvents() {
		wordGapEvent();
		usbAudioEvent();
		immersiveReaderEvent();
		lockedQuestionSequenceExamEvent();
	});
	dxEvent.create(DX_EVENT_NAME.PageviewGradingOverview);
});
